export default __webpack_public_path__ + "static/media/like (2).0dd71e31.png";